module.exports = __webpack_public_path__ + "static/img/card2.fcf84bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card2.png
// module id = JvkK
// module chunks = 2